import React from "react";
import "./SharedStyles.scss";

interface IProps {
  children: any;
}

const EAElevatedContainer: React.FC<IProps> = ({ children }) => {
  return <div className="elevated-container">{children}</div>;
};

export default EAElevatedContainer;
